<div class="quick-actions">
  @if (version?.isAuthorized('CONVOCATION') && user.isAuthorized('OP_CONVOCATION')) {
  <a class="quick-action" [routerLink]="['convocations']">
    <i class="fal fa-inbox-in"></i>
    <span>Convocations</span>
  </a>
  }
  @if (version?.isAuthorized('FORMULAIRES') && user.isAuthorized('OP_FORM_READ')) {
  <a class="quick-action" [routerLink]="['formulaires/absence']">
    <i class="fal fa-bullhorn"></i>
    <span>Absence</span>
  </a>
  }
  @if (version?.isAuthorized('MATERIEL') && user.isAuthorized('OP_BOOKING_READ')) {
  <a class="quick-action" [routerLink]="['booking', 'calendar']" [queryParams]="{ ecawin: true }">
    <i class="fal fa-calendar-alt"></i>
    <span>Calendrier</span>
  </a>
  }
  @if (version?.isAuthorized('ROULAGE') && user.isAuthorized('OP_BOOKING_CREATE')) {
  <a class="quick-action" [routerLink]="['roulage', 'saisir-rapport']">
    <i class="fal fa-truck"></i>
    <span>Roulage</span>
  </a>
  }
  @if (version?.isAuthorized('APR') && user.isAuthorized('OP_APR_READ')) {
  <a class="quick-action" [routerLink]="['apr']">
    <i class="fal fa-fire-extinguisher"></i>
    <span>APR</span>
  </a>
  }
</div>
